import { type FC, useEffect, useState } from 'react'

import { Button, Grid, Stack, Typography } from '@mui/material'
import { CustomInput, RHFCustomSelect } from '@core/components/ui'
import { useLayout } from '@core/contexts/layout'

import { MobileWrapper } from '../../../@core/components/layout/MobileWrapper/MobileWrapper'
import { type DNIFormData } from './DNISchema'
import { useDNIForm } from './useDNIForm'

interface Props {
  onSubmitDNIForm: (data: DNIFormData) => Promise<void>
  isFamiliar?: boolean
  wrapperMaxWidth?: string | number
}

export const DNIForm: FC<Props> = ({ onSubmitDNIForm, isFamiliar, wrapperMaxWidth }) => {
  const {
    control,
    errors,
    isSubmitting,
    onSubmit,
    values,
    documentTypes,

    handleSubmit,
    onChangeDocumentNumber
  } = useDNIForm({ onSubmitDNIForm })

  const [documentToShow, setDocumentToShow] = useState('DNI')
  const { isMobile } = useLayout()

  useEffect(() => {
    if (values.documentType === 1) setDocumentToShow('DNI')
    if (values.documentType === 2) setDocumentToShow('Pasaporte')
    if (values.documentType === 3) setDocumentToShow('Carnet de Extranjería')
  }, [values.documentType])

  return (
    <Stack component='form' onSubmit={handleSubmit(onSubmit)}>
      <MobileWrapper maxWidth={wrapperMaxWidth} pb={0}>
        <Grid
          container
          columnSpacing={isMobile ? '1.6rem' : '2.4rem'}
          rowSpacing={isMobile ? '1.6rem' : '3.2rem'}
        >
          <Grid item min={12}>
            <Typography
              mt={isMobile ? '0.8rem' : undefined}
              variant={
                isMobile ? (isFamiliar ? 'h2_bold' : 'd3') : isFamiliar ? 'h3_bold' : 'h1_bold'
              }
              color='secondary'
            >
              {isFamiliar ? (
                <>
                  Ingresa el {documentToShow} de{' '}
                  <span style={{ color: 'var(--color-primary)' }}>tu familiar</span>
                </>
              ) : (
                <>
                  Ingresa tu <span style={{ color: 'var(--color-primary)' }}>{documentToShow}</span>
                </>
              )}
            </Typography>
          </Grid>

          <Grid item min={6} display='flex' flexDirection='column'>
            <RHFCustomSelect
              control={control}
              options={documentTypes ?? []}
              label='Tipo de documento'
              name='documentType'
            />
          </Grid>

          <Grid item min={6} display='flex' flexDirection='column'>
            <CustomInput
              label='Nº de documento'
              value={values.documentNumber}
              onChange={onChangeDocumentNumber}
              name='documentNumber'
              error={Boolean(errors?.documentNumber)}
              helperText={errors?.documentNumber?.message}
              inputMode='numeric'
            />
          </Grid>

          <Grid mt='1.2rem' mb={5} item min={12} display='flex' flexDirection='column'>
            <Button disabled={isSubmitting} sx={{ my: 1 }} size='large' type='submit'>
              Continuar
            </Button>
          </Grid>
        </Grid>
      </MobileWrapper>
    </Stack>
  )
}
